import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import B2BRentalsTable from "./tables/B2BRentals.table";

function B2BRentalsPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <B2BRentalsTable />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}

export default B2BRentalsPage;
